import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/nominas/tasas-ipejal/';
/**
 * GET IPEJAL Tasas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIPEJALtasas = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET IPEJAL Tasas
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getIPEJALtasa = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST IPEJAL Tasas
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postIPEJALtasa = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH IPEJAL Tasas
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchIPEJALtasa = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE IPEJAL Tasas
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteIPEJALtasa = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR IPEJAL Tasas
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarIPEJALtasa = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
